import { FORM_ERROR_NAME_RESPONSIBLE_MANAGERS_LIMIT_EXCEEDED } from '../../Form.constants'

export function getResponsibleManagersFieldErrorProps(error) {
  return {
    error:
      error === FORM_ERROR_NAME_RESPONSIBLE_MANAGERS_LIMIT_EXCEEDED || error,
  }
}
